<template>
  <div class="chbox" :class="{ 'chbox_smtext': smtext, 'chbox_tostart': tostart, 'chbox_radio': radio_like }">
    <input tabindex="-1" type="checkbox" class="chbox__input" :checked="val" :name="name" :disabled="disabled">
    <div role="checkbox" :aria-checked="val" :tabindex="disabled ? false : 0" class="chbox__tick" :class="{ 'chbox__tick_disabled': disabled }" @click="disabled ? false : (val = !val)" @keydown.enter.space.stop="disabled ? false : (val = !val)">
      <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 8L6 12L14 2" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <div class="chbox__text" :class="{ 'chbox__text_asterisk': required }" @click="!disabled ? (val = !val) : false">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
  }),
  props: {
    modelValue: { type: Boolean, required: true },
    disabled: { type: Boolean, default: false },
    smtext: { type: Boolean, default: false },
    radio_like: { type: Boolean, default: false },
    tostart: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    name: { type: String, required: true },
  },
  unmounted() {
    try {
      this.$emit('update:modelValue', false)
      //eslint-disable-next-line
    } catch (err) {
    }
  },
  computed: {
    val: {
      get() {
        return this.modelValue
      },
      set(v) {
        this.$emit('update:modelValue', v)
      }
    }
  },
  watch: {
    /*
    val(v, old) {
      if (v != old)
        this.$store.dispatch('callAction', this.name)
    }*/
  }
}
</script>

<style lang="sass">
.chbox
  min-height: 24px
  display: flex
  align-items: center
  margin-bottom: 20px
  @include for-mob
    &_smtext
      align-items: flex-start
  &_tostart
    align-items: flex-start
  &__input
    position: absolute
    opacity: 0
    pointer-events: none
  &__text
    cursor: pointer
    font-size: 16px
    line-height: 1.12
    a
      color: colors.$newred
    &_asterisk::after
      content: '*'
      color: colors.$newred
      font-weight: 400
      display: inline-block
      transform: translateY(-1px)
  &_smtext &__text
    font-size: 14px
    line-height: 1.12
  &__tick
    margin-right: 16px
    &, *
      outline: none
    position: relative
    transform: translateY(-1px)
    z-index: 1
    &::before
      content: ''
      position: absolute
      top: -15px
      left: -15px
      right: -15px
      bottom: -15px
    display: flex
    justify-content: center
    align-items: center
    width: 24px
    min-width: 24px
    height: 24px
    border: 2px solid colors.$bluefont5b
    cursor: pointer
    transition: border-color .2s ease-out
    &_disabled
      &, & + .chbox__text
        cursor: auto
        pointer-events: none
    svg
      transition: opacity .2s ease-out
      stroke: colors.$newred
      opacity: 0
    &:hover, &:focus-within
      border-color: colors.$newgray
    &[aria-checked=true]
      border-color: colors.$newgray
      &:focus-within
        border-color: colors.$bluefont4b
      svg
        opacity: 1
  &_radio &__tick
    border-radius: 50%

    &[aria-checked=true]
      border-color: colors.$gray7
      &:focus-within
        border-color: colors.$bluefont4b
      &::after
        content: ''
        display: block
        background: colors.$newred
        width: 12px 
        height: 12px
        border-radius: 50%
    svg
      display: none
</style>